// BCM-898 · Goods Receipt Dashboard — shared Resubmit Document button.
// Used by PA2, PA4, PA6 and by the View Digitalized Information page.
// Opens the same two-dialog flow as Reset Batch (ResetBatchDialog ->
// DocumentResubmissionDialog) — ResubmitReasonDialog (batch + reason, step 1)
// followed by ResubmitDocumentDialog (document table + comments, step 2). The
// batch is pre-populated with the row the button was pressed on but stays
// editable; the batch chosen in step 1 is carried into step 2.
// `activeDocType` (optional) is the document type of whichever tab was open
// when the button was pressed — step 2 pre-targets that document type's row,
// still editable, instead of defaulting to the first fetched option.
//
// Success is reported with the shared GRFeedbackContext toast (auto-closes, no OK
// button). No refresh: resubmitting a document doesn't change the batch's pending
// action, so the main table and action box are deliberately left alone (25-Aug
// review: no refresh needed for this action).
import React, { useState } from "react";
import { Button } from "@material-ui/core";
import { useGRStyles } from "../../goodsReceiptStyles";
import { useGRFeedback } from "../../context/GRFeedbackContext";
import ResubmitReasonDialog from "./ResubmitReasonDialog";
import ResubmitDocumentDialog from "./ResubmitDocumentDialog";

const ResubmitDocumentButton = ({ row, detail, disabled, blue, activeDocType, featuresAccess }) => {
  const classes = useGRStyles();
  const [reasonOpen, setReasonOpen] = useState(false);
  const [documentOpen, setDocumentOpen] = useState(false);
  const [reasonForReset, setReasonForReset] = useState("");
  // The batch chosen in step 1 (pre-populated with this row, but editable).
  const [selectedBatch, setSelectedBatch] = useState(null);
  const feedback = useGRFeedback();

  // resetBatch is the same getFeaturesAccess flag that gates the "Reset Batch"
  // button this reuses the dialog flow from (sasl/batchesDetails/index.jsx).
  // Must be explicitly true — a missing flag means not granted, not "allowed
  // by default" (this button previously had no featuresAccess check at all).
  if (!featuresAccess || !featuresAccess.resetBatch) return null;

  return (
    <React.Fragment>
      <Button
        className={blue ? classes.blueBtn : classes.outlinedBtn}
        disableElevation
        onClick={() => setReasonOpen(true)}
        disabled={disabled}
      >
        Resubmit Document
      </Button>

      <ResubmitReasonDialog
        open={reasonOpen}
        onClose={() => setReasonOpen(false)}
        row={row}
        detail={detail}
        onContinue={(reason, batch) => {
          setReasonForReset(reason);
          setSelectedBatch(batch);
          setReasonOpen(false);
          setDocumentOpen(true);
        }}
      />

      <ResubmitDocumentDialog
        open={documentOpen}
        onClose={() => setDocumentOpen(false)}
        row={row}
        detail={detail}
        selectedBatch={selectedBatch}
        reasonForReset={reasonForReset}
        activeDocType={activeDocType}
        onSuccess={() => {
          setDocumentOpen(false);
          feedback.notifySuccess({
            message: "Document Resubmission Request sent to CMO Successfully",
          });
        }}
      />

    </React.Fragment>
  );
};

export default ResubmitDocumentButton;
